import React, { Component } from "react";
import PropTypes from "prop-types";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { activeFormatter } from "Utils/Acciones/Acciones";
import ProductoForm from "./ProductoCrearForm";
import ProductoCrearFormSeccionado from './ProductoCrearFormSeccionado';
import { api } from "api";

class ProductoCrear extends Component {
    static propTypes = {
        submit: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            archivo: null,
            n: false,
            treeData: [{ title: "Chicken", children: [{ title: "Egg" }] }],
            seleccion_unidades_medida: false,
            sucursal: null,
            sucursal_activo: null,
        };
        this.onFileChange = this.onFileChange.bind(this);
        this.crearProducto = this.crearProducto.bind(this);
    }

    onFileChange(e, file, key) {
        file = file || e.target.files[0];
        const pattern = /image-*/;
        const reader = new FileReader();
        if (file) {
            if (!file.type.match(pattern)) {
                alert("Formato inválido");
                return;
            }
            // this.setState({ loaded: false });
            reader.onload = (e) => {
                // this.setState({
                //   imageSrc: reader.result,
                //   loaded: true
                // });
                // const clave = this.props.clave;
                // console.log(file,reader);
                // this.props.setFile(file);
                this.setState({ [key]: e.target.result, [key + '_file']: file });
            };
            reader.readAsDataURL(file);
        }
    }

    cambioSeleccionUnidad = (estado) => {
        this.setState({ seleccion_unidades_medida: estado });
    };

    componentWillMount() {
        this.props.inicializarProducto();
        this.props.getCategorias();
    }

    crearProducto() {
        const fotos = [{ name: "imagen", file: this.state.foto_producto_file || this.state.foto_producto }];
        Object.keys(this.state).forEach((item) => {
            if (item.includes("catalogo_") && !item.endsWith('_file')) {
                fotos.push({
                    name: item,
                    file: this.state[item + '_file'] || this.state[item],
                });
            }
        });
        this.props.submit(fotos, !!this.props.location.state);
    }

    changeSucursal = (value) => {
        this.setState({ sucursal: value });
    };

    changeSucursalActivo = (id) => {
        this.setState({
            sucursal_activo: this.state.sucursal_activo === id ? null : id,
        });
    };
    render() {
        // state
        const {
            forms,
            unidades_de_medida_empresa,
            loader,
            conf_tienda_online,
            categorias,
            categorias_seleccionados,
            categorias_expanded,
            lista_sucursales,
            nombres_precios,
            conf_porcentaje_precio,
            familias,
        } = this.props;
        // bind
        const {
            submit,
            cambioTipoProducto,
            regresar,
            asignarCategoria,
            setCategoriasExpanded,
            cambioPorcentajePrecio,
            conf_tipo_negocio,
            conf_nueva_interfaz_productos,
        } = this.props;

        const getFamilias = (search) => {
            return api
                .get(`familia/?sin_paginacion=true`, { search })
                .then((data) => {
                    const listaFamilias = data.map((item) => ({
                        id: item.id,
                        nombre: item.nombre,
                    }));
                    return { options: listaFamilias };
                })
                .catch((err) => {
                    console.error("Error al obtener las familias:", err);
                    return { options: [] }; // Devuelve un array vacío en caso de error
                });
        };

        const catalogoProps = {};
        Object.keys(this.state).forEach(function(key) {
            if (key.startsWith('catalogo_') && !key.endsWith('_file')) {
                catalogoProps[key] = this.state[key];
            }
        }.bind(this));

        const commonProps = {
            conf_tienda_online,
            loader,
            crearProducto: this.crearProducto,
            onFileChange: this.onFileChange,
            cambioSeleccionUnidad: this.cambioSeleccionUnidad,
            forms,
            deBodega: !!this.props.location.state,
            unidades_de_medida_empresa,
            seleccion_unidades_medida: this.state.seleccion_unidades_medida,
            cambioTipoProducto,
            regresar,
            foto_producto: this.state.foto_producto,
            categorias,
            categorias_seleccionados,
            categorias_expanded,
            asignarCategoria,
            setCategoriasExpanded,
            sucursales: lista_sucursales,
            sucursal: this.state.sucursal,
            sucursal_activo: this.state.sucursal_activo,
            changeSucursal: this.changeSucursal,
            changeSucursalActivo: this.changeSucursalActivo,
            cambioPorcentajePrecio,
            nombres_precios,
            conf_porcentaje_precio,
            familias,
            getFamilias,
            conf_tipo_negocio,
            es_admin: this.props.es_admin,
            editar_precio: this.props.editar_precio,
            foto_producto: this.state.foto_producto,
            ...catalogoProps,
        };

        console.log("ESTO ESS conf_nueva_interfaz_productos: ", conf_nueva_interfaz_productos);

        return (
            <div className="row mt">
                <div className="col-lg-12 col-md-12 col-sm-12">
                    {/* <h1>Nuevo producto</h1> */}
                    {
                        conf_nueva_interfaz_productos
                            ? <ProductoCrearFormSeccionado {...commonProps} />
                            : <ProductoForm {...commonProps} />
                    }
                </div>
            </div>
        );
    }
}

export default ProductoCrear;